import styled, { createGlobalStyle } from 'styled-components'

const CmsContainer = styled.div`
  margin-top: 15px;
`

const PropbarContainer = styled.div`
  margin-bottom: 15px;
`

const CmsGlobalStyle = createGlobalStyle`
.container--events-clearance {
    [data-test='m0012'] {
      background-color: ${(props) => props.theme.tokens.color.palette.brand4};

      [data-test='m0012-image'] {
        background-image: none !important;
        display: none;
      }
    }

    [data-test='m035'] {
      a {
        background-color: ${(props) => props.theme.tokens.color.palette.brand4};
        color: ${(props) => props.theme.tokens.color.monochrome.black};
      }
    }

    .m002 {
      & > div:first-child,
      &__link-background {
        background-color: ${(props) => props.theme.tokens.color.palette.brand4};
        color: ${(props) => props.theme.tokens.color.monochrome.black};
      }

      &__header,
      &__link {
        color: ${(props) => props.theme.tokens.color.monochrome.black};
      }

      &__cta button {
        color: ${(props) => props.theme.tokens.color.monochrome.black};
        border-color: ${(props) => props.theme.tokens.color.monochrome.black};
        background-color: ${(props) => props.theme.tokens.color.palette.brand4};
      }

      &__svg--chevron {
        fill: ${(props) => props.theme.tokens.color.monochrome.black};
      }

      &__svg--expand {
        color: black;
      }
    }
  }

.m022 {
  flex: 1 1 auto !important;

  &__quote {
    border-color: #ccc;
  }
}

.m0043 {
  height: auto !important;
  min-height: auto !important;
}

.gl0043 {
  .m010 {
    display: grid;
  }

  .m0044 {
    @media (min-width: ${(props) => props.theme.screen_sm_min}) {
      margin: 0;
    }
    .ac-product-card__cta-row {
      @media (max-width: ${(props) => props.theme.screen_md_min}) {
        right: 0;
        left: unset;
        .ac-product-cta {
          margin-right: 0;
        }
      }
      @media (min-width: ${(props) => props.theme.screen_md_min}) {
        margin-bottom: 15px;
      }
    }
    border-bottom: 0;
  }
}
`
export { CmsContainer, CmsGlobalStyle, PropbarContainer }
